"use strict";
// Decode XML entities
// &amp; gt; &lt; &quot; &apos;
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeEntities = decodeEntities;
const entityMap = {
    amp: "&",
    gt: ">",
    lt: "<",
    quot: '"',
    apos: "'",
};
const reEntities = /&(amp|gt|lt|quot|apos);/g;
function decodeEntities(str) {
    if (!str || str.length < 4)
        return str;
    // This is a global regex, so we need to reset lastIndex
    reEntities.lastIndex = 0;
    return str.replace(reEntities, (_match, entity) => entityMap[entity]);
}
//# sourceMappingURL=decode-entities.js.map